module.exports = [
	"advice:archive",
	"advice_article:news_insights",
	"archive:archive",
	"dot_realtor:agent_details",
	"dotrealtor:agent_details",
	"finance:affordability_calc_input1",
	"finance:affordability_calc_input2",
	"finance:affordability_calculator",
	"finance:affordability_calculator_results_rcm",
	"finance:buy_vs_rent_calculator",
	"finance:castling_no_result",
	"finance:castling_screen1",
	"finance:castling_screen2",
	"finance:castling_screen3",
	"finance:connect_with_an_agent",
	"finance:home_buying_checklist",
	"finance:landing",
	"finance:loan_home",
	"finance:loan_home_estimate_home_value",
	"finance:loan_home_get_pre_approved",
	"finance:mortgage_calculator",
	"finance:mortgage_rate_table",
	"finance:quicken_rates_page",
	"finance:rate_table_heloc",
	"finance:rate_table_heloc_no_results",
	"finance:rate_table_purchase_city",
	"finance:rate_table_purchase_loan_type",
	"finance:rate_table_purchase_state",
	"finance:rate_table_refinance",
	"finance:refi",
	"finance:refinance_calculator",
	"finance:refinance_rate_table",
	"finance:sitemap",
	"finance:trend",
	"finance:veterans",
	"finance_tab:landing",
	"for_rent:browse",
	"for_rent:landing",
	"for_rent:ldp",
	"for_rent:ldp-quickview",
	"for_rent:srp_list",
	"for_rent:srp_map",
	"for_sale:bdp",
	"for_sale:browse",
	"for_sale:home",
	"for_sale:landing",
	"for_sale:ldp",
	"for_sale:ldp-quickview",
	"for_sale:mal",
	"for_sale:srp_list",
	"for_sale:srp_map",
	"global:ccpa_landing",
	"local:businesses",
	"local:city",
	"local:county",
	"local:district",
	"local:home",
	"local:homes-for-sale",
	"local:housing-market",
	"local:landing",
	"local:neighborhood",
	"local:neighborhoods",
	"local:postal_code",
	"local:school",
	"local:schools",
	"local:state",
	"marketing-about:advertise",
	"marketing-about:awards",
	"marketing-about:brands",
	"marketing-about:careers",
	"marketing-about:contact",
	"marketing-about:equalhousing",
	"marketing-about:investors",
	"marketing-about:jobs",
	"marketing-about:landing",
	"marketing-about:leadership",
	"marketing-about:privacy",
	"marketing-about:termsofuse",
	"marketing-agentprofile:landing",
	"marketing-akc17:landing",
	"marketing-betterwaytobuy:landing",
	"marketing-cashreward:landing",
	"marketing-consumerchoice:landing",
	"marketing-contentcorner:landing",
	"marketing-coronaVirus:recovery_center",
	"marketing-coronaVirus:recovery_center_buyers",
	"marketing-coronaVirus:recovery_center_finances",
	"marketing-coronaVirus:recovery_center_renters",
	"marketing-coronaVirus:recovery_center_sellers",
	"marketing-coronavirus:landing",
	"marketing-covidescape:landing",
	"marketing-cpname:landing",
	"marketing-estimates:landing",
	"marketing-findrealtor:landing",
	"marketing-firsttimebuyer:landing",
	"marketing-floodRisk:landing",
	"marketing-gardenstatesupport:landing",
	"marketing-goodneighbor19:awards",
	"marketing-goodneighbor19:landing",
	"marketing-goodneighbor19:winner",
	"marketing-halloween19:landing",
	"marketing-hgtvsweepsentryway20k:thankYou",
	"marketing-hispanic18:landing",
	"marketing-hispanictx17:homebuying:article1",
	"marketing-hispanictx17:homebuying:article4",
	"marketing-hohs:landing",
	"marketing-homebuying:landing",
	"marketing-mediasolutions:landing",
	"marketing-mobile:androidCoreApp",
	"marketing-mobile:androidRentalsApp",
	"marketing-mobile:iPadCoreApp",
	"marketing-mobile:iPhoneCoreApp",
	"marketing-mobile:iPhoneRentalsApp",
	"marketing-mobile:landing",
	"marketing-mobile:tabletCoreApp",
	"marketing-mortgage101:landing",
	"marketing-realconnections:landing",
	"marketing-realpeople:landing",
	"marketing-resource:buyer",
	"marketing-resource:landing",
	"marketing-resource:mortgage-process",
	"marketing-resource:other-resources",
	"marketing-resource:owners",
	"marketing-resource:resource",
	"marketing-resource:sellers-and-homeowners",
	"marketing-trainthetrainer-global:landing",
	"marketing-trainthetrainer-re:landing",
	"misc:captcha",
	"misc:error",
	"misc:error_404",
	"misc:error_408",
	"misc:error_500",
	"misc:fraud_alert",
	"misc:ip_blocked",
	"misc:sitemap",
	"my_acct:hidden_listings",
	"my_acct:login",
	"my_acct:profile",
	"my_acct:properties",
	"my_acct:searches",
	"my_acct:seller_report",
	"my_home:design",
	"my_home:home_value",
	"my_home:homelight_buying_intent",
	"my_home:homelight_landing",
	"my_home:homelight_lead_submit_step",
	"my_home:homelight_lead_submit_success",
	"my_home:landing",
	"my_home:mortgage_equity",
	"my_home:neighborhood",
	"my_home:remodeling",
	"my_home:selling_tools",
	"news_article:news_insights",
	"news_insights:advice_article",
	"news_insights:advice_category",
	"news_insights:advice_guide",
	"news_insights:author",
	"news_insights:home",
	"news_insights:landing",
	"news_insights:news_article",
	"news_insights:news_catgory",
	"news_insights:sponsored_article",
	"news_insights:video_browse",
	"news_insights:video_details",
	"news_insights:video_hub",
	"not_for_sale:browse",
	"not_for_sale:landing",
	"not_for_sale:ldp",
	"not_for_sale:ldp-quickview",
	"not_for_sale:sellers_marketplace",
	"not_for_sale:sellers_marketplace:availability",
	"not_for_sale:sellers_marketplace:results_available",
	"not_for_sale:sellers_marketplace:schedule_call",
	"not_for_sale:sellers_marketplace:success",
	"not_for_sale:srp_list",
	"not_for_sale:srp_map",
	"podcast:article",
	"podcast:category",
	"realtors:agent_details",
	"realtors:landing",
	"realtors:office_details",
	"realtors:srp_list",
	"realtors:srp_map",
	"realtors:team_details",
	"research:about",
	"research:about_danielle_hale",
	"research:about_george_ratiu",
	"research:about_javier_vivas",
	"research:about_nicolas_bedo",
	"research:about_press_room",
	"research:about_sabrina_speianu",
	"research:about_team",
	"research:blog",
	"research:blog_affordability_blog_filter",
	"research:blog_article",
	"research:blog_economic_coverage_blog_filter",
	"research:blog_hottest_markets_blog_filter",
	"research:landing",
	"research:local_market_insights_blog_filter",
	"research:reports_cross_market_demand",
	"research:reports_landing",
	"research:reports_luxury_index",
	"research:reports_market_outlooks",
	"research:research_hottestmarkets",
	"research:research_housing_demand",
	"research:research_landing",
	"research:research_luxury_housing",
	"research:research_market_outlook",
	"sell:landing",
	"sell:seller_summary",
	"syndicated_realtors:agent_details"
];


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/@moveinc/rdc-tracking/distribution/constants/page_names_whitelist.json
// module id = 711
// module chunks = 48 49 50